function* wrap(source) {
  yield* source;
}

exports.wrap = wrap;

function* nullableWrap(source) {
  if (source != null) {
    yield* source;
  }
}

exports.nullableWrap = nullableWrap;